import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  progressBarBox: {
    display: 'flex',
    width: '100%',
    borderRadius: '10px',
    overflow: 'hidden',
    backgroundColor: '#e0e0e0',
    height: '1vh', // Default height for the progress bar
    [theme.breakpoints.down('xxl')]: {
      height: '0.5vh'
    },
    [theme.breakpoints.down('xl')]: {
      height: '1.7vh'
    },
    [theme.breakpoints.down('md')]: {
      height: '0.7vh'
    }
  }
}));

export default useStyles;
